export enum EmployeeRolesEnum {
    ADMIN = "ADMIN",
    USER = "USER"
}